module.exports = __webpack_public_path__ + "static/media/sun.307f5eda.svg";